exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contaner[data-v-37ee7872] {\n  min-height: 80vh;\n  padding: 0 20px;\n  background-color: #fff;\n  border-radius: 10px;\n}\n", ""]);

// exports
